var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"minus-button",attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.onClick}},[_vm._v(" - ")])
}
var staticRenderFns = []

export { render, staticRenderFns }